import {Injectable} from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import {Observable} from "rxjs";
import {EstudioService} from "../estudio.service";
import { HttpResponse } from "@angular/common/http";
import {Periodo} from "../../../_models/interfaces";


@Injectable({
  providedIn: 'root'
})
export class EstudioResumenResolver  {

    constructor(private router: Router, private estudioService: EstudioService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)/*: Observable<HttpResponse<Periodo[]>> */{
        return this.estudioService.getPeriodos(true)/*.map(periodos => {
            return periodos;
        })*/;
    }
}
